// src/pages/task/components/list/List.tsx
import React, { useEffect, useRef } from 'react'
import { TaskInterface } from '../../../../common/types/interfaces'
import classes from './List.module.sass'
import { Item } from './Item'

type Props = {
  tasks: TaskInterface[]
  loading: boolean
  loadingMore: boolean
  hasMore: boolean
  error: string | null
  onLoadMore: () => void
}

export const List: React.FC<Props> = ({
  tasks,
  loading,
  loadingMore,
  hasMore,
  error,
  onLoadMore,
}) => {
  const observerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!hasMore || loadingMore || loading) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          onLoadMore()
        }
      },
      { threshold: 0.1 },
    )

    const target = observerRef.current
    if (target) observer.observe(target)

    return () => {
      if (target) observer.unobserve(target)
    }
  }, [hasMore, loadingMore, loading, onLoadMore])

  if (error && tasks.length === 0) {
    return <div className={classes.error}>{error}</div>
  }

  if (!tasks.length) {
    return <div className={classes.message}>Заданий нет</div>
  }

  return (
    <div className={classes.container}>
      {tasks.map((task) => (
        <Item key={`${task.clusterId}-${task.id}`} task={task} />
      ))}

      {hasMore && (
        <div ref={observerRef} className={classes.loadMoreTrigger}>
          {loadingMore ? 'Загрузка...' : ''}
        </div>
      )}

      {!hasMore && tasks.length > 0 && <div className={classes.end}>Больше заданий нет</div>}
    </div>
  )
}
